import React, { useEffect } from "react";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./components/ui/Toast";
import { setAuthContext } from "./api";
import ErrorBoundary from "./components/ErrorBoundary";
import { appRoutes } from "./routes/router";

const router = createBrowserRouter(appRoutes);

// Component to set auth context
const AuthContextSetter: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  useEffect(() => {
    console.log(
      "🔄 AuthContextSetter: Ensuring API Client is initialized for session-based auth",
    );
    setAuthContext();
  }, []);

  return <>{children}</>;
};

// Route errors are handled by the router's errorElements; this boundary only
// catches crashes in the providers around it.
const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ToastProvider>
          <AuthContextSetter>
            <RouterProvider router={router} />
          </AuthContextSetter>
        </ToastProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
};

export default App;
